module.exports = __webpack_public_path__ + "static/media/posizione.af04245f.svg";